import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SetupError", "Missing panel parameter", config.defaultMessageId)